import {gql} from 'apollo-angular';
import {StatusFragment} from "../fragments/Status";

export const SET_GAME_END = gql`
  query GetGame1($gameId: Int!, $gameEnd: GameEndType!, $points: Int!) {
    setGameEnd(gameID: $gameId, gameEnd: $gameEnd, points: $points) {
      ...statusFields
    }
  }

  ${StatusFragment}
`;
